import { Link } from "react-router-dom";
import { Leaf, Phone, Mail, MapPin, Globe } from "lucide-react";
import { SITE } from "@/data/content";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#355C4A] text-[#EAF0EA] mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10">
              <Leaf strokeWidth={1.5} className="w-5 h-5 text-[#C9A96A]" />
            </span>
            <span className="font-serif text-2xl text-white">{SITE.name}</span>
          </div>
          <p className="text-[#C7D4C9] font-light leading-relaxed max-w-xs">
            A safe, confidential and non-judgmental space to pause, reflect,
            heal and move forward at your own pace.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-xl text-white mb-4">Explore</h4>
          <ul className="space-y-2.5 text-[#C7D4C9]">
            <li><Link data-testid="footer-link-home" to="/" className="hover:text-[#C9A96A] transition-colors">Home</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="hover:text-[#C9A96A] transition-colors">About Us</Link></li>
            <li><Link data-testid="footer-link-services" to="/services" className="hover:text-[#C9A96A] transition-colors">My Services</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-[#C9A96A] transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-xl text-white mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-[#C7D4C9]">
            <li className="flex items-center gap-3"><Phone strokeWidth={1.5} className="w-4 h-4 text-[#C9A96A]" /><span>{SITE.phone}</span></li>
            <li className="flex items-center gap-3"><Mail strokeWidth={1.5} className="w-4 h-4 text-[#C9A96A]" /><span>{SITE.email}</span></li>
            <li className="flex items-center gap-3"><MapPin strokeWidth={1.5} className="w-4 h-4 text-[#C9A96A]" /><span>{SITE.location}</span></li>
            <li className="flex items-center gap-3"><Globe strokeWidth={1.5} className="w-4 h-4 text-[#C9A96A]" /><span>{SITE.website}</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-[#A9BBAC]">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <p>Counselling by {SITE.counsellor}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
